// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"342f0cbb","559":"394d2237","616":"a977f22c","787":"48436d71"}[chunkId] + ".chunk.js";
};